import React from "react";
import ContentfulRichText from "../../utilities/contentful-rich-text";
import isTooDark from "../../utilities/is-too-dark";
import Carousel from "../carousel";
import { GatsbyImage, StaticImage, getImage } from "gatsby-plugin-image";
import CarouselType from "../../types/carousel.type";

const SimpleText = ({
  className,
  innerClassName,
  images,
  backgroundColor,
  text,
  carouselOptions,
}: {
  className?: string;
  innerClassName?: string;
  images: any[];
  backgroundColor: string;
  text: { raw: string };
  carouselOptions?: Partial<CarouselType>;
}) => {
  const textColor = isTooDark(backgroundColor) ? "#ffffff" : "#000000";
  return (
    <div
      className={`"text-center simple-text-section relative z-10 ${className}`}
      style={{ backgroundColor: backgroundColor, color: textColor }}
    >
      <div
        className={`inner-container simple-text-container py-20 md:py-32 ${
          isTooDark(backgroundColor) ? " dark-bg" : ""
        } ${innerClassName}`}
      >
        {text && <ContentfulRichText raw={text} className="text-[20px] text-left" />}
        {images?.length > 0 && (
          <div className="w-full overflow-hidden mt-8">
            <Carousel
              edgesFade={false}
              dots={true}
              showArrows={true}
              slidesToScroll={2}
              slidesToShow={2}
              infinite={true}
              data={images.map((image) => {
                return (
                  <GatsbyImage
                    className="rounded-[50px] md:rounded-[50px]"
                    key={image.id}
                    image={
                      getImage(image.localFile.childImageSharp.gatsbyImageData)!
                    }
                    alt={image.title}
                  />
                );
              })}
              arrowsElements={{
                left: (
                  <StaticImage src="../../images/left-round-arrow.png" alt="" />
                ),
                right: (
                  <StaticImage
                    src="../../images/right-round-arrow.png"
                    alt=""
                  />
                ),
              }}
              arrowsPosition={{ left: "0", right: "0" }}
              {...carouselOptions}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default SimpleText;
